import styled from 'styled-components';

export const Actions = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(1)};
  padding-left: ${({ theme }) => theme.spacing(6.5)};
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;
